import * as Actions from '../../../../redux/actions'

import {
    CalendarDuotoneIcon,
    PlaneArrivalIcon,
    PlaneDepartureIcon,
    TimesIcon,
} from "../SVGBank"

import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import DatePicker from "react-datepicker"
import React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getAirportsListThunk } from '../../FlightsPage/services/Flights.thunks'
import moment from 'moment'
import { getIPFromAmazon } from '../../HotelPage/hotelServices'
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowRightArrowLeft, faArrowsUpDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { calculatePercentageDifference, getDates, getFlightsByDate } from '../../FlightsPage/services/flights.services'
import { environment } from '../../../../Environments/environment'
import { filterAirports } from './bookingFormHelper'
import PriceWithSuperscript from '../../FlightsPage/flightsComponents'
import { useMediaQuery, useTheme } from '@material-ui/core'

const FlightFormFlightElementRoundTrip_ = ({ startSearch, embedded, flipDirection, departingFlight, returningFlight, setFlightsData, is_mobile, lang, error, getAirportList }) => {
    const dispatch = useDispatch()
    const useEmbedded = environment?.production ? false : true

    const [rawAirportList, setRawAirportList] = React.useState([]);
    const [filteredAirportList, setFilteredAirportList] = React.useState([]);
    let departingDate = departingFlight.departureDateFormat && moment(departingFlight.departureDateFormat).toDate();
    let returningDate = returningFlight.departureDateFormat && moment(returningFlight.departureDateFormat).toDate();
    let [cachedPrices, setCachedPrices] = React.useState([])
    let [searching, setSearching] = React.useState(false)
    const location = useLocation()
    const isFlightsPage = location && location.pathname.includes("/flight");
    const [airportFrom, setAirportFrom] = React.useState(departingFlight.airportFrom)
    const [airportTo, setAirportTo] = React.useState(departingFlight.airportTo)
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const cabinClass = useSelector(state => state.Flights.flightData.cabinClass);
    const flightMode = useSelector(state => state.Flights.flightData.flightMode);
    const numberAdult = useSelector(state => state.Flights.flightData.numberAdult);
    const numberChild = useSelector(state => state.Flights.flightData.numberChild);
    const flights = useSelector(state => state.Flights.flightData.flights);
    const currency = useSelector(state => state.Setting.currency);
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode);
    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD";
    const [fetchDuration, setFetchDuration] = React.useState(7); // default to 7 days

    const [startDate, setStartDate] = React.useState(departingDate);
    const [endDate, setEndDate] = React.useState(returningDate);
    const priceCache = React.useRef(new Map())

    const [isReturnPickerOpen, setIsReturnPickerOpen] = React.useState(false);

    const openDatePicker = () => {
        setIsReturnPickerOpen(true);
    };



    const handleSelectedAirportsFrom = (airports) => {
        if (airports !== undefined) {
            setCachedPrices([])//clear cached prices
            priceCache.current.clear() // clear the price cache ref
            setAirportFrom(airports.length > 0 ? airports[0] : null)
            setFlightsData(departingFlight, airports.length > 0 ? airports[0] : null, airportTo, departingDate)
        }
    }

    const handleSelectedAirportsTo = (airports) => {
        if (airports !== undefined) {
            setCachedPrices([])//clear cached prices
            priceCache.current.clear() // clear the price cache ref
            setAirportTo(airports.length > 0 ? airports[0] : null)
            setFlightsData(returningFlight, airports.length > 0 ? airports[0] : null, airportFrom, returningDate)

        }
    }

    const handleChangeDepartureDate = (date) => {
        setFlightsData(departingFlight, airportFrom, airportTo, date)

        openDatePicker()
    }

    const handleSelectDate = (date, isReturnDate = false) => {

        // If this is a return date picker selection
        if (isReturnDate) {
            // If no start date exists, set this as start date
            if (!startDate) {
                setStartDate(date)
                setEndDate(null)
                setFlightsData(departingFlight, airportFrom, airportTo, date)
                fetchPrices(date)
            }
            // If start date exists, set or update end date
            else {
                setEndDate(date)
                setFlightsData(returningFlight, airportTo, airportFrom, date)
                // Close the calendar after selecting return date
                setTimeout(() => {
                    setIsReturnPickerOpen(false);
                }, 100);
            }
        }
        // This is a departure date picker selection
        else {
            // If start date is not set, set it
            if (!startDate) {
                setStartDate(date)
                setFlightsData(departingFlight, airportFrom, airportTo, date)
                fetchPrices(date)
                // Automatically open the return date picker
                setTimeout(() => {
                    openDatePicker()
                }, 100)
            }
            // If both dates are set, reset and start fresh
            else if (startDate && endDate) {
                setStartDate(date)
                setEndDate(null)
                setFlightsData(departingFlight, airportFrom, airportTo, date)
                fetchPrices(date)
                // Automatically open the return date picker
                setTimeout(() => {
                    openDatePicker()
                }, 100)
            }
            // If start date is set but not end date, update start date if the new date is before current start
            else if (moment(date).isBefore(startDate, 'day')) {
                setStartDate(date)
                setEndDate(null)
                setFlightsData(departingFlight, airportFrom, airportTo, date)
                fetchPrices(date)
                // Automatically open the return date picker
                setTimeout(() => {
                    openDatePicker()
                }, 100)
            }
            // If the selected date is after start date and no end date, set it as end date
            else if (moment(date).isAfter(startDate, 'day')) {
                setEndDate(date)
                setFlightsData(returningFlight, airportTo, airportFrom, date)
            }
            // Same day selection
            else {
                setStartDate(date)
                setEndDate(null)
                setFlightsData(departingFlight, airportFrom, airportTo, date)
                fetchPrices(date)
                // Automatically open the return date picker
                setTimeout(() => {
                    openDatePicker()
                }, 100)
            }
        }

    }

    const handleChangeReturnDate = (date) => {
        setFlightsData(returningFlight, airportTo, airportFrom, date)
    }

    const handleSearchAirports = useDebouncedCallback(async (query) => {
        const result = await dispatch(getAirportsListThunk(query));
        if (result?.payload) {
            setRawAirportList(result.payload); // Optional if you want full backup

            const filtered = filterAirports(result.payload, query);
            setFilteredAirportList(filtered);
        }
    }, 500);

    React.useEffect(() => {
        setCachedPrices([]) // clear cached prices when airportFrom changes
        priceCache.current.clear() // clear the price cache ref
        setFlightsData(returningFlight, airportTo, airportFrom, returningDate)
    }, [airportFrom]);

    React.useEffect(() => {
        setCachedPrices([]) // clear cached prices when airportTo changes
        priceCache.current.clear() // clear the price cache ref
        setFlightsData(departingFlight, airportFrom, airportTo, departingDate)
    }, [airportTo]);


    React.useEffect(() => {
        setCachedPrices([]) // clear cached prices when departingFlight changes
        priceCache.current.clear() // clear the price cache ref
        setAirportFrom(departingFlight.airportFrom);
        setAirportTo(departingFlight.airportTo);
    }, [departingFlight]);


    React.useEffect(() => {
        const shouldPrefill =
            airportFrom &&
            airportTo &&
            !startDate && // user hasn't selected yet
            !endDate &&
            !departingFlight?.departureDateFormat &&
            !returningFlight?.departureDateFormat;

        if (shouldPrefill) {
            const defaultStart = moment().add(3, 'days').startOf('day').toDate();
            const defaultEnd = moment(defaultStart).add(4, 'days').toDate();



            // fetchPrices(defaultStart);
        }
    }, [
        airportFrom,
        airportTo,
        startDate,
        endDate,
        departingFlight?.departureDateFormat,
        returningFlight?.departureDateFormat
    ]);


    React.useEffect(() => {
        const getAddress = async () => {
            const airport = await getIPFromAmazon();
            if (airport && !airportFrom) { //airportFrom not set
                setAirportFrom(airport)
                setFlightsData(departingFlight, airport, airportTo, departingDate)
            }
        }
        if (!isFlightsPage) {
            getAddress()
        }

    }, [])

    const renderDayContents = React.useCallback((day, date) => {
        const formatted = moment(date).format("YYYY-MM-DD");
        const price = priceCache.current.get(formatted);
        let priceColor = "#ccc";

        if (cachedPrices?.length > 0 && price != null) {
            const sorted = [...cachedPrices].sort((a, b) => a.price - b.price);
            const total = sorted.length;

            const greenCount = Math.ceil(total / 3);
            const redCount = Math.floor(total / 3);
            const orangeCount = total - greenCount - redCount;

            const greenGroup = sorted.slice(0, greenCount).map(p => moment(p.date).format("YYYY-MM-DD"));
            const orangeGroup = sorted.slice(greenCount, greenCount + orangeCount).map(p => moment(p.date).format("YYYY-MM-DD"));
            const redGroup = sorted.slice(greenCount + orangeCount).map(p => moment(p.date).format("YYYY-MM-DD"));

            if (greenGroup.includes(formatted)) priceColor = `var(--mainGreen)`;
            else if (redGroup.includes(formatted)) priceColor = `var(--mainRed)`;
            else if (orangeGroup.includes(formatted)) priceColor = `var(--mainOrange)`;
        }

        const isSelected = startDate && endDate && moment(date).isBetween(startDate, endDate, 'day', '[]');

        return (
            <div>
                {price && !is_mobile && useEmbedded ? (
                    <div style={{
                        textAlign: "right",
                        padding: 5,
                        borderRadius: 10,
                        borderBottom: `10px solid ${priceColor}`,
                        // background: isSelected ? "rgba(25, 188, 155, 0.2)" : "transparent"
                    }}>
                        <div>{day}</div>
                        <div style={{ font: "Futura Md BT" }}>{currency?.selected?.symbol || "$"}<PriceWithSuperscript amount={price} decimalPlace={2} style={{ fontWeight: 800 }} /></div>
                    </div>
                ) : (
                    <div style={{
                        padding: 5,
                        borderRadius: 10,
                        borderBottom: `10px solid transparent`,
                        // background: isSelected ? "rgba(25, 188, 155, 0.2)" : "transparent",
                        textAlign: "right"
                    }}>
                        <div>{day}</div>
                        <div style={{ visibility: "hidden" }}>placeholder</div>
                    </div>
                )}

            </div>

        );
    }, [cachedPrices, startDate, endDate, currency]);


    const calendarClosed = async () => {

    }

    const fetchPrices = async (baseDate) => {
        const startDate = moment(baseDate).subtract(fetchDuration, "days");
        const endDate = moment(baseDate).add(fetchDuration, "days");

        // Generate dates in the desired "zig-zag" order around the baseDate
        const center = moment(baseDate);
        const datesInOrder = [center];
        for (let i = 1; i <= fetchDuration; i++) {
            const next = moment(baseDate).add(i, "days");
            const prev = moment(baseDate).subtract(i, "days");
            if (next.isSameOrBefore(endDate)) datesInOrder.push(next);
            if (prev.isSameOrAfter(startDate)) datesInOrder.push(prev);
        }

        const dataToBookingFlights = {
            flightMode,
            cabinClass,
            numberAdult,
            numberChild,
            flights,
            currency: fullCurrency
        };

        for (const date of datesInOrder) {
            const formatted = date.format("YYYY-MM-DD");
            if (priceCache.current.has(formatted)) continue;

            const payload = {
                ...dataToBookingFlights,
                flights: [
                    { ...flights?.[0], departureDateFormat: formatted },
                    { ...flights?.[1], departureDateFormat: formatted }
                ],
                dateFormat: formatted
            };

            try {
                const data = await getFlightsByDate(payload);
                const price = data?.itinerary_data?.[0]?.price_details?.display_total_fare;

                if (price != null) {
                    priceCache.current.set(formatted, price);
                    setCachedPrices(prev => [...(prev || []), { date: formatted, price }]);
                }
            } catch (e) {
                console.error("Error loading price for", formatted, e);
            }
        }
    };








    return (
        <div className={`${useEmbedded ? `embeddedDates` : ''} row m-0 p-0 w-100 mt-3 flightRoundTripForm`} style={{ padding: "1px", border: airportFrom !== null && airportTo !== null && airportFrom.iata === airportTo.iata ? "1px solid red" : "" }}>
            <div className="col-12 col-md-6 col-xl-4 p-0">
                <div className="position-relative fromAirport" style={{ border: airportFrom === null && error ? "1px solid red" : "" }}>
                    <AsyncTypeahead

                        id="flight-airport-from-typeahead-departing-from"
                        labelKey={(option) => {
                            return (option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                `${option.iata} - ${option.airport}`)
                        }}
                        filterBy={() => true}
                        onChange={(e) => handleSelectedAirportsFrom(e)}
                        options={filteredAirportList}
                        placeholder="From"
                        shouldSelect={true}
                        minLength={1}
                        onSearch={query => handleSearchAirports(query)}
                        renderMenuItemChildren={(option) => {
                            return (<div key={option?.id} user={option} style={{
                                font: option.type === "main" ? "16px/30px Futura Md BT" : "",
                                paddingLeft: option.type === "sub" ? 20 : 0
                            }}>

                                {option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                    `${option.iata} - ${option.airport}`
                                }
                            </div>)
                        }}
                        selected={airportFrom ? [airportFrom] : []}
                        isLoading={false}
                        delay={100}
                        clearButton={is_mobile ? false : true}
                        multiple={false}
                    />
                    <div className="position-absolute" style={{ top: is_mobile ? "10px" : "14px", left: "7px" }}>
                        <PlaneDepartureIcon width={15} height={15} />
                    </div>
                </div>
            </div>




            <div className="col-12  col-md-6 col-xl-4 p-0">

                <div className="position-relative toAirport" style={{ border: airportTo === null && error ? "1px solid red" : "" }}>
                    <AsyncTypeahead

                        id="light-airport-to-typeahead-going-to"
                        labelKey={(option) => {
                            return (option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                `${option.iata} - ${option.airport}`)
                        }}
                        onChange={(e) => handleSelectedAirportsTo(e)}
                        options={filteredAirportList}
                        placeholder="To"
                        filterBy={() => true}
                        shouldSelect={true}
                        minLength={1}
                        onSearch={query => handleSearchAirports(query)}
                        renderMenuItemChildren={(option) => {
                            return (<div key={option.id} user={option} style={{
                                font: option.type === "main" ? "16px/30px Futura Md BT" : "",
                                paddingLeft: option.type === "sub" ? 20 : 0
                            }}>

                                {option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                    `${option.iata} - ${option.airport}`
                                }
                            </div>)
                        }}
                        isLoading={false}
                        selected={airportTo ? [airportTo] : []}
                        delay={100}
                        clearButton={is_mobile ? false : true}
                        multiple={false}
                    />
                    <div className="switchButton" style={{
                        position: 'absolute',
                        top: is_mobile ? "10px" : "14px",
                        left: is_mobile ? 0 : "-17px",
                        right: is_mobile ? 2 : null,
                        borderRadius: '50%',
                        width: is_mobile ? 30 : 35,
                        height: is_mobile ? 30 : 35,
                        background: 'white',
                        border: '1px solid #202020',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }} onClick={flipDirection}>
                        {smallScreen ? <div style={{ padding: 1, cursor: "pointer", textAlign: "center", display: 'flex', gap: 2 }}>
                            <FontAwesomeIcon icon={faArrowUp} style={{ color: '#202020', fontSize: is_mobile ? '12px' : '14px' }} />
                            <FontAwesomeIcon icon={faArrowDown} style={{ color: '#202020', fontSize: is_mobile ? '12px' : '14px' }} />
                        </div> :
                            <div style={{ padding: 1, cursor: "pointer", textAlign: "center" }}>
                                <FontAwesomeIcon icon={faArrowRightArrowLeft} style={{ color: '#202020', fontSize: is_mobile ? '12px' : '14px' }} />
                            </div>
                        }
                    </div>

                    <div className="position-absolute" style={{ top: is_mobile ? "10px" : "14px", left: "7px" }}>
                        <PlaneArrivalIcon width={15} height={15} />
                    </div>

                </div>
            </div>
            <div className="col-6 col-xl-2 p-0">
                <div className="position-relative" style={{ border: departingDate === "" && error ? "1px solid red" : "" }}>
                    <DatePicker
                        selected={startDate}
                        startDate={startDate}
                        endDate={endDate}
                        selectsEnd
                        shouldCloseOnSelect={false}
                        showPopperArrow={false}

                        onCalendarClose={calendarClosed}
                        monthsShown={useEmbedded && !is_mobile ? 2 : 1}
                        isClearable={false}
                        renderDayContents={useEmbedded ? renderDayContents : null}
                        // startDate={departingDate}
                        // endDate={returningDate}
                        onChange={(date) => handleSelectDate(date, false)}
                        placeholderText="Departure"
                        dateFormat={"yyyy/MM/dd" || "yyyy-mm-dd"}
                        minDate={new Date()}
                        // maxDate={returningDate ? new Date(returningDate) : null}
                        className="form-control" />
                    <div className="position-absolute" style={{ top: is_mobile ? "12px" : "14px", left: "7px" }}>
                        <CalendarDuotoneIcon width={15} height={15} />
                    </div>
                </div>
            </div>
            <div className="col-6 col-xl-2 p-0">
                <div className="position-relative dateTo" style={{ border: returningDate === "" && error ? "1px solid red" : "" }}>
                    <DatePicker
                        selected={endDate}
                        startDate={startDate}
                        endDate={endDate}
                        selectsEnd
                        open={isReturnPickerOpen}
                        onInputClick={() => setIsReturnPickerOpen(true)}
                        onCalendarClose={() => setIsReturnPickerOpen(false)}
                        showPopperArrow={false}
                        monthsShown={useEmbedded && !is_mobile ? 2 : 1}
                        isClearable={false}

                        renderDayContents={useEmbedded ? renderDayContents : null}
                        // startDate={departingDate}
                        // endDate={returningDate}
                        onChange={(date) => handleSelectDate(date, true)}
                        placeholderText="Return"
                        dateFormat={"yyyy/MM/dd" || "yyyy-mm-dd"}
                        minDate={startDate || new Date()}
                        // maxDate={returningDate ? new Date(returningDate) : null}
                        className="form-control" />
                    <div className="position-absolute" style={{ top: is_mobile ? "12px" : "14px", left: "7px" }}>
                        <CalendarDuotoneIcon width={15} height={15} />
                    </div>
                </div>
            </div>
        </div>

    )
}

const mapStateToProps = (state) => ({
    lang: state.Setting.lang,
    is_mobile: state.Setting.is_mobile,
})

const mapDispatchToProps = {
    getAirportList: Actions.getAirportList,
}

const FlightFormFlightElementRoundTrip = connect(mapStateToProps, mapDispatchToProps)(FlightFormFlightElementRoundTrip_)
export default FlightFormFlightElementRoundTrip


export function useDebouncedCallback(callback, delay) {
    const timeoutRef = React.useRef();

    const debouncedFn = (...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    };

    React.useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
    }, []);

    return debouncedFn;
}